package com.kinoshazam.uiKit.components.genreItem

import androidx.compose.ui.graphics.painter.Painter

data class GenreItemState(
    val id: Int,
    val title: String,
    val icon: Painter,
)
